import { downloadAsset } from "@store/actions/downloads";
import { TTrack } from "@store/actions/track";
import { AppDispatch } from "@store/store";

export const downloadFile = async (url: string, titleForDownloading: string, dispatch: AppDispatch) => {
  try {
    // const blob = await DownloadService.downloadFile(url);
    const blob = await dispatch(downloadAsset({ url })).unwrap();

    const a = document.createElement("a");
    a.style.display = "none";

    const blobURL = window.URL.createObjectURL(blob);
    a.href = blobURL;
    a.download = titleForDownloading;

    a.click();

    window.URL.revokeObjectURL(blobURL);
  } catch (error) {
    console.error("Error:", error);
  }
};

export const downloadZip = async (url: string, titleForDownloading: string, dispatch: AppDispatch) => {
  // const blob = await DownloadService.downloadFile(url);
  const blob = await dispatch(downloadAsset({ url })).unwrap();

  const csvURL = window.URL.createObjectURL(blob);

  const tempLink = document.createElement("a");

  tempLink.href = csvURL;
  tempLink.setAttribute("download", `${titleForDownloading}.zip`);
  tempLink.click();
};

export const getTitleForDownloading = (trackData: TTrack): string => {
  let artist: string;

  if (!trackData?.composer) {
    artist = "Paste Artist";
  } else if (typeof trackData.composer === "string") {
    artist = trackData.composer;
  } else {
    artist = (trackData.composer as any)?.name || "Paste Artist";
  }

  return `${artist} - ${trackData?.name}`;
};
